/**
 * Discord OAuth redirect target. Runs inside the popup opened by
 * `openDiscordOAuthPopup` (discord-oauth.ts): it relays the `code` (or error)
 * from the query string back to the opener via `postMessage`, then closes.
 *
 * Must be a bare route (no app layout) — it renders for a fraction of a second
 * in a tiny popup and never needs the sidebar/video chrome or auth.
 */

import { useEffect } from 'react';

export default function DiscordOAuthCallbackPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = {
      type: 'discord-oauth' as const,
      code: params.get('code') ?? undefined,
      state: params.get('state') ?? undefined,
      // Prefer the short `error` code (e.g. access_denied) over the verbose
      // description so the opener can normalize a cancel cleanly.
      error: params.get('error') ?? params.get('error_description') ?? undefined,
    };
    // Target our own origin only — never post the code to a wildcard.
    window.opener?.postMessage(message, window.location.origin);
    window.close();
  }, []);

  return (
    <p style={{ padding: 24, textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      Finishing Discord sign-in… you can close this window.
    </p>
  );
}
